import { useContext, useState } from "react";
import api from "../services/api";
import axios from "axios";
import { AuthContext } from "../providers/AuthProvider";

type UpdateProfileParams = {
  tipoDocumento: string | null | undefined;
  pais: string | number | undefined;
  departamento: string | number | undefined;
  city_id: string | number | undefined;
  nombreCompleto: string | undefined;
  email: string | undefined;
  telefono: string | undefined;
  numeroDocumento: number | string | undefined;
  password: string | undefined;
  password_confirmation: string | undefined;
};

type UpdateProfileErrors = {
  tipoDocumento: string[];
  pais: string[];
  departamento: string[];
  city_id: string[];
  nombreCompleto: string[];
  direccion: string[];
  email: string[];
  telefono: string[];
  numeroDocumento: string[];
  password: string[];
  server: string[];
};

const DEFAULT_ERRORS: UpdateProfileErrors = {
  tipoDocumento: [""],
  pais: [""],
  departamento: [""],
  city_id: [""],
  nombreCompleto: [""],
  direccion: [""],
  email: [""],
  telefono: [""],
  numeroDocumento: [""],
  password: [""],
  server: [""],
};

const useUpdateProfile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState<UpdateProfileErrors>(DEFAULT_ERRORS);

  const serverError = () => {
    setErrors({
      ...DEFAULT_ERRORS,
      server: ["No se pudo realizar el registro"],
    });
  };

  const { onUpdateProfile } = useContext(AuthContext);

  const updateClientProfile = ({
    client_id,
    params,
    onSuccess,
  }: {
    client_id: number | undefined;
    params: UpdateProfileParams;
    onSuccess: () => void;
  }) => {
    setIsLoading(true);
    return api
      .post(`/update-client-profile/${client_id}`, params)
      .then((response) => {
        onUpdateProfile(response.data.cliente);
        setErrors(DEFAULT_ERRORS);
        onSuccess();
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          if (error.response?.status === 422) {
            setErrors({ ...DEFAULT_ERRORS, ...error.response?.data });
          } else {
            serverError();
          }
        } else {
          serverError();
        }
      })
      .finally(() => setIsLoading(false));
  };

  return { updateClientProfile, isLoading, errors };
};

export default useUpdateProfile;
